import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy account path now lives in the dashboard.
export const Route = createFileRoute('/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
